import React from 'react'
import { NpsQuestion, NpsResponseValue } from '../types/nps.types'
import NpsRating from './NpsRating'
import NpsMultipleChoice from './NpsMultipleChoice'
import NpsText from './NpsText'

interface Props {
    question: NpsQuestion
    value: NpsResponseValue | undefined
    onChange: (value: NpsResponseValue) => void
    error?: string
}

const NpsQuestionRenderer: React.FC<Props> = ({ question, value, onChange, error }) => {
    switch (question.type) {
        case 'rating':
            return <NpsRating question={question} value={typeof value === 'number' ? value : undefined} onChange={onChange} error={error} />
        case 'multiple-choice':
            return <NpsMultipleChoice question={question} value={typeof value === 'string' ? value : undefined} onChange={onChange} error={error} />
        case 'text':
            return <NpsText question={question} value={typeof value === 'string' ? value : undefined} onChange={onChange} error={error} />
        default:
            return null
    }
}

export default NpsQuestionRenderer
